<template>
    <div class="stepOne">
        <Spin size="large" fix v-if="spinShow"></Spin>
        <headers></headers>
        <div class="content">
            <steps :step-num="0"></steps>
            <div class="stepOne-form">
                <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
                    <FormItem :label-width="0" prop="loginNo">
                        <Input v-model="formValidate.loginNo" placeholder="请输入学号/工号"></Input>
                    </FormItem>
                    <FormItem :label-width="0" prop="loginName">
                        <Input v-model="formValidate.loginName" placeholder="请输入姓名"></Input>
                    </FormItem>
                    <FormItem :label-width="0" prop="city">
                        <Select v-model="formValidate.idType" placeholder="请选择证件类型">
                            <Option value="0">居民身份证</Option>
                            <Option value="1">护照</Option>
                            <Option value="2">港澳台居民身份证</Option>
                            <Option value="4">旅行证据</Option>
                            <Option value="5">其他</Option>
                        </Select>
                    </FormItem>
                    <FormItem :label-width="0" prop="idNo">
                        <Input v-model="formValidate.idNo" placeholder="请输入证件号"></Input>
                    </FormItem>
                    <FormItem :label-width="0" prop="code">
                        <Row>
                            <Col span="16">
                                <Input v-model="formValidate.code" placeholder="请输入图片中的字符，不限大小写"></Input>
                            </Col>
                            <Col span="1"></Col>
                            <Col span="5">
                                <div @click="refreshCode" style="cursor: pointer;">
                                    <Sidentify :identifyCode="identifyCode" ></Sidentify>
                                </div>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem :label-width="0">
                        <Button type="primary" long @click="handleSubmit('formValidate')">下一步</Button>
                    </FormItem>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
    import Sidentify from '../../components/identify.vue'
    import headers from '../../components/pc/header.vue'
    import steps from '../../components/pc/steps.vue'
    import * as utils from '../../utils'
    export default {
        name: "stepOne",
        components: {
            headers,
            steps,
            Sidentify
        },
        data() {
            const validatePassCheck = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入验证码'));
                } else if (value.toLowerCase() !== this.identifyCode.toLowerCase()) {
                    callback(new Error('验证码不正确'));
                } else {
                    callback();
                }
            };
            return {
                spinShow: false,
                ruleValidate: {
                    loginNo: [{ required: true, message: '请输入学号/工号', trigger: 'blur' }],
                    loginName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                    idNo: [{ required: true, message: '请输入证件号', trigger: 'blur' }],
                    code: [{ validator: validatePassCheck, message: '请输入验证码', trigger: 'blur' }],
                },
                formValidate: {
                    loginNo: '',
                    loginName: '',
                    idType: '0',
                    idNo: '',
                    code: '',
                },
                identifyCode: '',
                identifyCodes: ['a','b','c','d','e','f','g','h','i','j','k','m','n','p','q','r','s','t','u','v','w','x','y','z','A','B','C','E','F','G','H','J','K','L','M','N','P','Q','R','S','T','W','X','Y','Z','1','2','3','4','5','6','7','8','9','0']
            }
        },
        created() {
            localStorage.removeItem('services')
            this.makeCode(4)
        },
        methods: {
            refreshCode() {
                this.identifyCode = ''
                this.makeCode(4)
            },
            makeCode(num) {
                for(let i=0;i<num;i++) {
                    let nums = Math.floor(Math.random() * (this.identifyCodes.length - 0) + 0)
                    this.identifyCode += this.identifyCodes[nums]
                }
            },
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.spinShow = true
                        this.refreshCode()
                        utils.Post('https://authserver.nbt.edu.cn/accountActive-nbt/nbtActivateAccount/getUnActivateUser',this.formValidate).then(res => {
                            if(res.data.data) {
                                this.$store.commit('changeInfo',res.data.data)
                                this.$store.commit('changeCard',this.formValidate.idNo)
                                this.$router.push({path: '/stepTwo',query: {service: this.$route.query.service}})
                            } else {
                                this.$Message.error(res.data.errMsg)
                            }
                            this.spinShow = false
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
.content{
    width: 800px;
    margin: 50px auto 0;
}
    .stepOne-form{
        width: 360px;
        margin: 50px auto 0;
    }
</style>



// WEBPACK FOOTER //
// stepOne.vue?45ad400a